import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const masonryImages = document.querySelector('.block-media-content.media-images')

let startVal = 'top +=65%'
let endVal = 'bottom -=65%'

if(window.innerWidth < 700) {
  startVal = 'top +=85%'
  endVal = 'bottom -=85%'
}

if(masonryImages) {

  gsap.utils.toArray(".image-1 img").forEach(function(image) {

    const block = image.closest('.block-media-content')
    const content = block.querySelector('.block-content')

    gsap.set(image, { y: '-102%'})
    gsap.set(content, { scale: 0.9, y: 50 })

    ScrollTrigger.create({
      trigger: block,
      start: startVal,
      end: endVal,
      once: true,
      onEnter: () => {
        gsap.to(image, { autoAlpha: 1, y: 0, duration: 0.75 })
        gsap.to(content, { scale: 1, y: 0, duration: 0.75 })
      }
    })

  })

  gsap.utils.toArray(".image-2 img").forEach(function(image) {

    const block = image.closest('.block-media-content')

    gsap.set(image, { autoAlpha: 0, y: '100%'})

    ScrollTrigger.create({
      trigger: block,
      start: startVal,
      end: endVal,
      once: true,
      onEnter: () => {
        gsap.to(image, { autoAlpha: 1, y: 0, duration: 0.75 })
      }
    })

  })

} else {

  startVal = 'top +=85%'
  endVal = 'bottom -=85%'


  gsap.utils.toArray(".block-media-content").forEach(function(block) {

    const image = block.querySelector('img')
    const video = block.querySelector('video')
    const content = block.querySelector('.block-content')

    if(image) {
      gsap.set(image, { opacity: 0, scale: 1.1})
    }

    if(video) {
      gsap.set(video, { opacity: 0})
    }

    gsap.set(content, {opacity: 0, y: 75})

    ScrollTrigger.create({
      trigger: block,
      start: startVal,
      end: endVal,
      once: true,
      //markers: true,
      onEnter: () => {
        if(image) {
          gsap.to(image, { autoAlpha: 1, scale: 1, delay: 0.2, duration: 0.75 })
        }

        if(video) {
          gsap.to(video, { autoAlpha: 1, y: 0, delay: 0.2, duration: 0.75 })
        }

        gsap.to(content, { autoAlpha: 1, y: 0, delay: 0.2, duration: 0.5 })
      }
    })

  })

}
